/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Start_ScreenInputs */

const th_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แชร์หน้าจอ`)
};

const en_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share screen`)
};

const ja_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面を共有`)
};

const zh_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共享屏幕`)
};

const es_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir pantalla`)
};

const pt_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar tela`)
};

const id_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan layar`)
};

const fr_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager l’écran`)
};

const tl_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ibahagi ang screen`)
};

const vi_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chia sẻ màn hình`)
};

const ko_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`화면 공유`)
};

const de_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildschirm teilen`)
};

const ru_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поделиться экраном`)
};

const tr_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekranı paylaş`)
};

const it_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi lo schermo`)
};

const pl_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udostępnij ekran`)
};

const uk_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поділитися екраном`)
};

const hi_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्क्रीन साझा करें`)
};

const ar_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشاركة الشاشة`)
};

const ms_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kongsi skrin`)
};

const bn_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পর্দা ভাগ করুন`)
};

const zh_tw2_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享螢幕`)
};

const zh_hk2_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享熒幕`)
};

const ur_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسکرین شیئر کریں`)
};

const fa_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هم‌رسانی صفحه`)
};

const sw_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shiriki skrini`)
};

const nl_video_start_screen = /** @type {(inputs: Video_Start_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scherm delen`)
};

/**
* | output |
* | --- |
* | "Share screen" |
*
* @param {Video_Start_ScreenInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_start_screen = /** @type {((inputs?: Video_Start_ScreenInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Start_ScreenInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_start_screen(inputs)
	if (locale === "ja") return ja_video_start_screen(inputs)
	if (locale === "zh") return zh_video_start_screen(inputs)
	if (locale === "es") return es_video_start_screen(inputs)
	if (locale === "pt") return pt_video_start_screen(inputs)
	if (locale === "id") return id_video_start_screen(inputs)
	if (locale === "fr") return fr_video_start_screen(inputs)
	if (locale === "tl") return tl_video_start_screen(inputs)
	if (locale === "vi") return vi_video_start_screen(inputs)
	if (locale === "ko") return ko_video_start_screen(inputs)
	if (locale === "de") return de_video_start_screen(inputs)
	if (locale === "ru") return ru_video_start_screen(inputs)
	if (locale === "tr") return tr_video_start_screen(inputs)
	if (locale === "it") return it_video_start_screen(inputs)
	if (locale === "pl") return pl_video_start_screen(inputs)
	if (locale === "uk") return uk_video_start_screen(inputs)
	if (locale === "hi") return hi_video_start_screen(inputs)
	if (locale === "ar") return ar_video_start_screen(inputs)
	if (locale === "ms") return ms_video_start_screen(inputs)
	if (locale === "bn") return bn_video_start_screen(inputs)
	if (locale === "zh-TW") return zh_tw2_video_start_screen(inputs)
	if (locale === "zh-HK") return zh_hk2_video_start_screen(inputs)
	if (locale === "ur") return ur_video_start_screen(inputs)
	if (locale === "fa") return fa_video_start_screen(inputs)
	if (locale === "sw") return sw_video_start_screen(inputs)
	if (locale === "nl") return nl_video_start_screen(inputs)
	return en_video_start_screen(inputs)
});